import PreviewNFTCard from "../card/PreviewNFTCard"
import { DialogActions, Grid, Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import React from "react"
import useMediaQuery from "@mui/material/useMediaQuery"
import { BASE_URL } from "../../constants/constants"
import { getUri } from "../../utils/getFullUrl"

export const DashboardWelcomeDialog = ({ item, closeDialog, maxWidth }) => {
  const isDownSm = useMediaQuery("(max-width: 600px)")

  return (
    <Box
      sx={{
        maxWidth,
        background: "#121212",
        textAlign: "center",
      }}
    >
      <DialogTitle sx={{ fontSize: "1rem", position: "relative", pr: 6 }}>
        Welcome to Zombie TD!
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 0 }}>
        <Typography
          mb={2}
          sx={{ whiteSpace: "pre-wrap", fontSize: { xs: 14 } }}
        >
          A special gift has been added to your account: your free NFT Base
          Commander.
        </Typography>
        <Grid container mb={2} spacing={2} sx={{ justifyContent: "center" }}>
          <Grid item md={6}>
            <PreviewNFTCard
              imageUrl={getUri(
                "img",
                "webp",
                item.type,
                item.name,
                item.rarity,
              )}
              videoUrl={getUri(
                "video",
                "mp4",
                item.type,
                item.name,
                item.rarity,
              )}
            />
          </Grid>
        </Grid>
        <Typography sx={{ whiteSpace: "pre-wrap", fontSize: { xs: 14 } }}>
          The battle is just beginning - stay alert and don’t miss the upcoming
          FCD and NFT Box Sale.
          <br />
          {!isDownSm && (
            <>
              Follow our socials to catch all the drops, events, and updates in
              time.
            </>
          )}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, width: "100%", justifyContent: "center" }}>
        <Stack flexWrap="wrap" direction="horizontal" useFlexGap spacing={1}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              closeDialog()
            }}
            sx={{ fontFamily: "RUSBoycott, sans-serif" }}
          >
            Go to Dashboard
          </Button>
        </Stack>
      </DialogActions>
    </Box>
  )
}
